import {
  faAngleRight,
  faAngleLeft,
  faAnglesLeft,
  faAnglesRight,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Pagination controls for a table of data
 */
export function Pagination({
  pageFirstRow,
  pageLastRow,
  totalRows,
  previousEnabled,
  previousOnClick,
  nextEnabled,
  nextOnClick,
  firstOnClick,
  lastOnClick,
  showFirstAndLastPageButtons,
}: {
  pageFirstRow: number;
  pageLastRow: number;
  totalRows: number;
  previousEnabled: boolean;
  previousOnClick: () => void;
  nextEnabled: boolean;
  nextOnClick: () => void;
  firstOnClick: () => void;
  lastOnClick: () => void;
  showFirstAndLastPageButtons?: boolean;
}) {
  return (
    <div className="flex items-center justify-end gap-5 text-sm text-gray-900">
      <div className="flex gap-1">
        {showFirstAndLastPageButtons && (
          <FirstLastButton
            destination="first"
            enabled={previousEnabled}
            onClick={firstOnClick}
          />
        )}
        <PrevNextButton
          direction="previous"
          enabled={previousEnabled}
          onClick={previousOnClick}
        />
      </div>

      <span>
        {pageFirstRow.toLocaleString()}-{pageLastRow.toLocaleString()} of{' '}
        {totalRows.toLocaleString()}
      </span>

      <div className="flex gap-1">
        <PrevNextButton
          direction="next"
          enabled={nextEnabled}
          onClick={nextOnClick}
        />
        {showFirstAndLastPageButtons && (
          <FirstLastButton
            destination="last"
            enabled={nextEnabled}
            onClick={lastOnClick}
          />
        )}
      </div>
    </div>
  );
}

function PrevNextButton({
  direction,
  enabled,
  onClick,
}: {
  direction: 'previous' | 'next';
  enabled: boolean;
  onClick: () => void;
}) {
  const text = direction === 'next' ? 'Next page' : 'Previous page';
  const icon = direction === 'next' ? faAngleRight : faAngleLeft;

  return (
    <button
      onClick={onClick}
      disabled={!enabled}
      className="px-0.5 disabled:opacity-50"
    >
      <span className="sr-only">{text}</span>
      <FontAwesomeIcon icon={icon} className="fa-width-auto text-2xl" />
    </button>
  );
}

function FirstLastButton({
  destination,
  enabled,
  onClick,
}: {
  destination: 'first' | 'last';
  enabled: boolean;
  onClick: () => void;
}) {
  const text = destination === 'last' ? 'Last page' : 'First page';
  const icon = destination === 'last' ? faAnglesRight : faAnglesLeft;

  return (
    <button
      onClick={onClick}
      disabled={!enabled}
      className="px-0.5 disabled:opacity-50"
    >
      <span className="sr-only">{text}</span>
      <FontAwesomeIcon icon={icon} className="fa-width-auto text-2xl" />
    </button>
  );
}
